"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeToMinutes = timeToMinutes;
exports.sanitizeTimeRanges = sanitizeTimeRanges;
exports.deriveRangeSegments = deriveRangeSegments;
exports.formatDurationMinutes = formatDurationMinutes;
/** Minutes since midnight for an `HH:mm` 24h time string. */
function timeToMinutes(value) {
    const [hours, minutes] = value.split(':').map(Number);
    return hours * 60 + minutes;
}
/** Drops empty ranges and returns a copy sorted by start time. */
function sanitizeTimeRanges(timeRanges) {
    return [...timeRanges]
        .filter((range) => range.startTime && range.endTime)
        .sort((a, b) => timeToMinutes(a.startTime) - timeToMinutes(b.startTime));
}
/**
 * Sorts the ranges and annotates each with the pause before it. The first
 * range and any non-positive (contiguous/overlapping) gap yield
 * `pauseBeforeMinutes: null`, so callers never render a "pause 0 min" line.
 */
function deriveRangeSegments(timeRanges) {
    const ordered = sanitizeTimeRanges(timeRanges);
    return ordered.map((range, index) => {
        const gap = index === 0
            ? null
            : timeToMinutes(range.startTime) -
                timeToMinutes(ordered[index - 1].endTime);
        return {
            startTime: range.startTime,
            endTime: range.endTime,
            pauseBeforeMinutes: gap !== null && gap > 0 ? gap : null,
        };
    });
}
/** Humanizes a positive minute count: 15→"15 min", 60→"1h", 90→"1h30". */
function formatDurationMinutes(minutes) {
    if (minutes < 60)
        return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes === 0
        ? `${hours}h`
        : `${hours}h${remainingMinutes.toString().padStart(2, '0')}`;
}
